import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Loading from "./page/Loading";
import Login from "./page/Login";
import Template from "./page/template";
import TemplateDocument from "./document/template";

import Notfound from "./page/notfound";

import Dashboard from "./page/admin/dashboard"; // หน้าหลัก

// ตั้งค่า
import Banks from "./page/admin/setting/banks"; // บัญชีธนาคาร
import Barcodes from "./page/admin/setting/barcodes"; // บาร์โค้ด 
import Categories from "./page/admin/setting/categories"; // หมวดหมู่ 
import Companies from "./page/admin/setting/companies"; // บริษัทที่จำหน่าย 
import CreateUpdateCustomers from "./page/admin/setting/create-update-customers"; // สร้าง/แก้ไข ลูกค้า
import Customers from "./page/admin/setting/customers"; // ลูกค้า
import PrintBarcodes from "./page/admin/setting/print-barcodes"; // พิมพ์บาร์โค้ด
import Roles from "./page/admin/setting/roles"; // บทบาท
import SpareParts from "./page/admin/setting/spare-parts"; // อะไหล่และการซ่อม
import Users from "./page/admin/setting/users"; // ผู้ใช้งาน 
import Warehouses from "./page/admin/setting/warehouses"; // คลังสินค้า

// สต็อก
import ReceiveGoods from "./page/admin/stock/receive-goods"; // รับสินค้า 
import CreateUpdateReceiveGoods from "./page/admin/stock/create-update-receive-goods"; // รับสินค้า 
import ReturnCustomerGoods from "./page/admin/stock/return-customer-goods"; // คืนสินค้าจากลูกค้า
import ReturnGoods from "./page/admin/stock/return-goods"; // คืนสินค้าให้ Sup
import StockChecks from "./page/admin/stock/stock-checks"; // เช็คสต็อก
import StockHistories from "./page/admin/stock/stock-histories"; // ประวัติสต็อก
import StockLists from "./page/admin/stock/stock-lists"; // สต็อกสินค้า
import WithdrawalGoods from "./page/admin/stock/withdrawal-goods"; // เบิกสินค้า

// ขาย
import Pos from "./page/admin/sale/pos"; // บันทึกรายการขาย

// รับชำระ
import OrderLists from "./page/admin/payment/order-lists"; // รายการสั่งซื้อ
import Payments from "./page/admin/payment/payments"; // รับชำระ
import PaymentLists from "./page/admin/payment/payments-lists"; // รายการชำระเงิน
import Histories from "./page/admin/payment/history-lists"; // รายการใบแจ้งหนี้

// ใบแล้วหนี้/ใบวางบิล 
import Invoices from "./page/admin/invoice/invoices"; // รายการใบแจ้งหนี้
import PaymentInvoices from "./page/admin/invoice/payment-invoices"; // รับชำระใบวางบิล
import Billings from "./page/admin/invoice/billings"; // ใบวางบิล 
import CreateBillings from "./page/admin/invoice/create-billings"; // รับชำระใบวางบิล
import PaymentBillings from "./page/admin/invoice/payment-billings"; // รับชำระใบวางบิล
import DebtReduces from "./page/admin/invoice/debt-reduces"; // ใบลดหนี้
import PaymentDebtReduces from "./page/admin/invoice/payment-debt-reduces"; // ใบลดหนี้

// การซ่อม
import DetailRepairs from "./page/admin/repair/detail-repairs"; // ข้อมูลใบแจ้งซ่อม 
import Repairs from "./page/admin/repair/repairs"; // รายการใบแจ้งซ่อม
import UpdateCost from "./page/admin/repair/update-cost"; // แก้ไขต้นทุน

// PDF
import DeliveryTaxInvoice from "./document/delivery-tax-invoice"; // รายการใบแจ้งซ่อม
import ReceiptTax from "./document/receipt-tax"; // ใบรับ
import Receipt from "./document/receipt"; // ใบรับ
import ProductReceipt from "./document/product-receipt"; // ใบรับสินค้า
import CarReceipt from "./document/car-receipt"; // ใบรับงาน
import ReturnClaim from "./document/return-claim"; // ใบคืน/เคลมสินค้าผู้จำหน่าย
import ReturnProduct from "./document/return-product"; // ใบคืนสินค้า
import ChangeProduct from "./document/change-product"; // ใบเปลี่ยนสินค้า
import Repair from "./document/repair"; // รายการซ่อม
import GetSpareParts from "./document/get-spare-parts"; // บิลเบิกอะไหล่ ซ่อม-ติดตั้ง
import DocBilling from "./document/billing"; // ใบวางบิล
import Quotation from "./document/quotation"; // ใบเสนอราคา
import Deposit from "./document/deposit"; // ใบมัดจำสินค้า
import Loan from "./document/loan"; // ใบยืมสินค้า
import Contract from "./document/contract"; // ใบสัญญายืมหรือซื้อสินค้าชั่วคราว
import CreditNote from "./document/credit-note"; // ใบลดหนี้
import InstallationSummary from "./document/installation-summary"; // ใบสรุปรายการติดตั้ง
import DeliveryNote from "./document/delivery-note"; // ใบส่งของ

// รายงาน
import ReportStatusDebtors from "./page/admin/report/status-debtors"; // รายการสถานะลูกหนี้
import ReportDialyDebtors from "./page/admin/report/dialy-debtors"; // รายการต่อวันเฉพาะลูกหนี้
import ReportOrderLists from "./page/admin/report/order-lists"; // รายการสั่งซื้อ
import ReportDepositLists from "./page/admin/report/deposit-lists"; // รายการมัดจำ
import ReportPaymentLists from "./page/admin/report/payment-lists"; // รายการชำระเงิน
import ReportRepairs from "./page/admin/report/repairs"; // รายการแจ้งซ่อม
import ReportInvoices from "./page/admin/report/invoices"; // รายการใบแจ้งหนี้
import ReportBillings from "./page/admin/report/billings"; // รายการใบวางบิล
import ReportDebtReduces from "./page/admin/report/debt-reduces"; // รายการใบลดหนี้
import ReportWithdrawalGoods from "./page/admin/report/withdrawal-goods"; // รายการเบิก
import ReportUpdateCost from "./page/admin/report/update-cost"; // รายงานต้นทุนซื้อ
import ReportSale from "./page/admin/report/sales"; // รายงานขาย
import ReportReceiveGoods from "./page/admin/report/receive-goods"; // รายงานรับสินค้า
import ReportConsolidatedGoods from "./page/admin/report/consolidated-goods"; // รายงานรับสินค้าแบบรวม
import ReportSupplierReturn from "./page/admin/report/supplier-return"; // รายงานคืนสินค้าให้ supplier
import ReportCustomerReturn from "./page/admin/report/customer-return"; // รายงานคืนสินค้าลูกค้า
import ReportCostUpdate from "./page/admin/report/cost-update"; // รายงานอัปเดทต้นทุน
// รายงานรับสินค้าแบบละเอียด
// รายงานรับสินค้าแบบรวม
// รายงานคืนสินค้าให้ sup
// รายงานเบิกสินค้า
// รายงานคืนสินค้าจากลูกค้า
// รายงานขายสินค้า
// รายงานมัดจำ
// รายงานสต็อกคงเหลือ
// รายงานเช็คสต็อก
// รายงานใบแจ้งซ่อม
// รายงานใบแจ้งหนี้
// รายงานใบวางบิล

// PDF

import PDFBarcode from "./document/barcode";

const AppRoutes = () => (
<Routes>
<Route path="/" element={<Loading />} />
<Route path="/login" element={<Login />} />
<Route path="/template" element={<Template />} />
<Route path="/document/template" element={<TemplateDocument />} />

<Route path="/dashboard" element={<Dashboard />} /> {/* บัญชีธนาคาร */}

<Route path="/setting/banks" element={<Banks />} /> {/* บัญชีธนาคาร */}
<Route path="/setting/barcodes" element={<Barcodes />} /> {/* บาร์โค้ด */}
<Route path="/setting/categories" element={<Categories />} /> {/* หมวดหมู่ */}
<Route path="/setting/companies" element={<Companies />} /> {/* บริษัทที่จำหน่าย */}
<Route path="/setting/customers/create" element={<CreateUpdateCustomers />} /> {/* สร้างลูกค้า */}
<Route path="/setting/customers/update" element={<CreateUpdateCustomers />} /> {/* แก้ไขลูกค้า */}
<Route path="/setting/customers" element={<Customers />} /> {/* ลูกค้า */}
<Route path="/setting/print-barcodes" element={<PrintBarcodes />} /> {/* พิมพ์บาร์โค้ด */}
<Route path="/setting/roles" element={<Roles />} /> {/* บทบาท */}
<Route path="/setting/spare-parts" element={<SpareParts />} /> {/* อะไหล่และการซ่อม */}
<Route path="/setting/users" element={<Users />} /> {/* ผู้ใช้งาน */}
<Route path="/setting/warehouses" element={<Warehouses />} /> {/* คลังสินค้า */}

<Route path="/stock/receive-goods" element={<ReceiveGoods />} /> {/* รับสินค้า */}
<Route path="/stock/receive-goods/view" element={<CreateUpdateReceiveGoods />} /> {/* รายละเอียดรับสินค้า */}
<Route path="/stock/receive-goods/create" element={<CreateUpdateReceiveGoods />} /> {/* สร้างรับสินค้า */}
<Route path="/stock/receive-goods/update" element={<CreateUpdateReceiveGoods />} /> {/* แก้ไขรับสินค้า */}
<Route path="/stock/return-customer-goods" element={<ReturnCustomerGoods />} /> {/* คืนสินค้าจากลูกค้า */}
<Route path="/stock/return-goods" element={<ReturnGoods />} /> {/* คืนสินค้าให้ Sup */}
<Route path="/stock/stock-checks" element={<StockChecks />} /> {/* เช็คสต็อก */}
<Route path="/stock/stock-histories" element={<StockHistories />} /> {/* ประวัติสต็อก */}
<Route path="/stock/stock-lists" element={<StockLists />} /> {/* สต็อกสินค้า  */}
<Route path="/stock/withdrawal-goods" element={<WithdrawalGoods />} /> {/* เบิกสินค้า */}

<Route path="/sale/pos" element={<Pos />} /> {/* บันทึกรายการขาย  */}

<Route path="/payment/order-lists" element={<OrderLists />} /> {/* รายการสั่งซื้อ */}
<Route path="/payment/payments" element={<Payments />} /> {/* รับชำระ */}
<Route path="/payment/payments-lists" element={<PaymentLists />} /> {/* รายการชำระเงิน */}
<Route path="/payment/history-lists" element={<Histories />} /> {/* รายการใบแจ้งหนี้ */}

<Route path="/invoice/invoices" element={<Invoices />} /> {/* รายการใบแจ้งหนี้ */}
<Route path="/invoice/payment-invoices" element={<PaymentInvoices />} /> {/* รายการใบแจ้งหนี้ */}
<Route path="/invoice/billings" element={<Billings />} /> {/* ใบวางบิล */}
<Route path="/invoice/create-billings" element={<CreateBillings />} /> {/* รับชำระใบวางบิล */}
<Route path="/invoice/payment-billings" element={<PaymentBillings />} /> {/* รับชำระใบวางบิล */}
<Route path="/invoice/debt-reduces" element={<DebtReduces />} /> {/* ใบลดหนี้ */}
<Route path="/invoice/payment-debt-reduces" element={<PaymentDebtReduces />} /> {/* ใบลดหนี้ */}

<Route path="/repair/detail-repairs" element={<DetailRepairs />} /> {/* ข้อมูลใบแจ้งซ่อม */}
<Route path="/repair/repairs" element={<Repairs />} /> {/* รายการใบแจ้งซ่อม  */}
<Route path="/repair/update-cost" element={<UpdateCost />} /> {/* แก้ไขต้นทุน  */}

<Route path="/doc/delivery-tax-invoice" element={<DeliveryTaxInvoice />} /> {/* ใบส่งของ/ใบกำกับภาษี  */}
<Route path="/doc/receipt" element={<Receipt />} /> {/* ใบรับ */}
<Route path="/doc/receipt-tax" element={<ReceiptTax />} /> {/* ใบรับ */}
<Route path="/doc/car-receipt" element={<CarReceipt />} /> {/* ใบรับงาน */} 
<Route path="/doc/product-receipt" element={<ProductReceipt />} /> {/* ใบรับสินค้า */}
<Route path="/doc/return-claim" element={<ReturnClaim />} /> {/* ใบคืน/เคลมสินค้าผู้จำหน่าย */}
<Route path="/doc/return-product" element={<ReturnProduct />} /> {/* ใบคืนสินค้า */ }
<Route path="/doc/change-product" element={<ChangeProduct />} /> {/* ใบเปลี่ยนสินค้า */}
<Route path="/doc/repair" element={<Repair />} /> {/* รายการซ่อม */}
<Route path="/doc/get-spare-parts" element={<GetSpareParts />} /> {/* บิลเบิกอะไหล่ ซ่อม-ติดตั้ง */}
<Route path="/doc/billing" element={<DocBilling />} /> {/* ใบวางบิล */}
<Route path="/doc/quotation" element={<Quotation />} /> {/* ใบเสนอราคา */}
<Route path="/doc/deposit" element={<Deposit />} /> {/* ใบมัดจำสินค้า */}
<Route path="/doc/loan" element={<Loan />} /> {/* ใบยืมสินค้า */}
<Route path="/doc/contract" element={<Contract />} /> {/* ใบสัญญายืมหรือซื้อสินค้าชั่วคราว */}
<Route path="/doc/credit-note" element={<CreditNote />} /> {/* ใบลดหนี้ */}
<Route path="/doc/installation-summary" element={<InstallationSummary />} /> {/* ใบสรุปรายการติดตั้ง */}
<Route path="/doc/delivery-note" element={<DeliveryNote />} /> {/* ใบส่งของ */}

<Route path="/report/status-debtor-reports" element={<ReportStatusDebtors />} /> {/* รายการสถานะลูกหนี้ */}
<Route path="/report/dialy-debtors-reports" element={<ReportDialyDebtors />} /> {/* รายการต่อวันเฉพาะลูกหนี้ */}
<Route path="/report/order-list-reports" element={<ReportOrderLists />} /> {/* รายการสั่งซื้อ */}
<Route path="/report/deposit-list-reports" element={<ReportDepositLists />} /> {/* รายการมัดจำ */}
<Route path="/report/payment-list-reports" element={<ReportPaymentLists />} /> {/* รายการชำระเงิน */}
<Route path="/report/invoice-reports" element={<ReportInvoices />} /> {/* รายการใบแจ้งหนี้ */}
<Route path="/report/billing-reports" element={<ReportBillings />} /> {/* รายการใบวางบิล */}
<Route path="/report/debt-reduce-reports" element={<ReportDebtReduces />} /> {/* รายการใบลดหนี้ */}
<Route path="/report/repair-reports" element={<ReportRepairs />} /> {/* รายการแจ้งซ่อม */}
<Route path="/report/withdrawal-good-reports" element={<ReportWithdrawalGoods />} /> {/* รายการเบิก */}
<Route path="/report/update-cost-reports" element={<ReportUpdateCost />} /> {/* รายงานต้นทุนซื้อ */}
<Route path="/report/sale-reports" element={<ReportSale />} /> {/* รายงานขาย */}
<Route path="/report/receive-good-reports" element={<ReportReceiveGoods />} /> {/* รายงานรับสินค้า */}
<Route path="/report/consolidated-good-reports" element={<ReportConsolidatedGoods />} /> {/* รายงานรับสินค้าแบบรวม */}
<Route path="/report/supplier-return-reports" element={<ReportSupplierReturn />} /> {/* รายงานคืนสินค้าให้ supplier */}
<Route path="/report/customer-return-reports" element={<ReportCustomerReturn />} /> {/* รายงานคืนสินค้าลูกค้า */}
<Route path="/report/cost-update-reports" element={<ReportCostUpdate />} /> {/* รายงานอัปเดทต้นทุน */}

<Route path="/pdf/barcode" element={<PDFBarcode />} /> {/* BARCODE  */}

<Route path="/*" element={<Notfound />} />
</Routes>
);

export default AppRoutes;
